<template>
  <div class="my-input" :style="{ 'border-bottom': border }" @click="inputClick">
    <p class="table">{{ table }}</p>
    <input type="text" :style="{ height,width, background }" :value="value" :disabled="disabled" :class="disabled ? 'disabled':''" @input="updateValue($event.target.value)" :placeholder="placeholder">
    <van-icon name="arrow" size="16px" v-if="table !== '开赛时间'" />
    <van-icon name="calendar-o" size="20px" v-else />
  </div>
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: ''
    },
    background: {
      type: String,
      default: ''
    },
    border: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String,Array],
      default: () => ''
    },
    placeholder: {
      type: String,
      default: '请输入'
    },
    table: {
      type: String,
      default: '赛事类型'
    }
  },
  data() {
    return {
      
    };
  },
  methods: {
    updateValue(newValue) {
      this.$emit('input', newValue);
    },
    inputClick() {
      this.$emit('inputClick')
    }
  },
};
</script>

<style scoped lang="scss">
.my-input{
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  background: #F9F9F9;
  border-radius: 2px;
  color: #191919;
  padding-right: 12px;
  p{
    min-width: 56px;
    font-size: 14px;
    margin: 0;
    padding: 19px 16px;
  }
  input{
    border: none;
    padding:0 10px;
    box-sizing: border-box;
    background-color: rgba(0,0,0,0);
    font-size: 14px;
    flex: 1;
  }
  .disabled{
    pointer-events: none !important;
  }
}
</style>
